import * as angular from 'angular';
import { ApiSettingsResource } from '../custom';

export interface SsoSettingsResource
    extends ng.resource.IResourceClass<ng.resource.IResource<boolean>>,
        ApiSettingsResource {
    restApiSetEnabled: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    restApiIsEnabled: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    restApiToken: ng.resource.IResourceMethod<
        ng.resource.IResource<JwtTokenDto>
    >;
    restApiSupported: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
    saveAllocationServiceSubscription: ng.resource.IResourceMethod<
        ng.resource.IResource<StoragePremiumServiceSubscriptionCreationDto>
    >;
    queryAllocationServiceSubscription: ng.resource.IResourceMethod<
        ng.resource.IResource<StoragePremiumServiceSubscriptionCreationDto>
    >;
    queryFcfsService: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    saveFcfsServiceEnabled: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    saveFcfsServiceUrls: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    creditLimitEnabled: ng.resource.IResourceMethod<
        ng.resource.IResource<boolean>
    >;
}

angular.module('app').factory('ssoSettingsResource', ssoSettingsResource);

function ssoSettingsResource(
    $resource: ng.resource.IResourceService,
    API_URL
): SsoSettingsResource {
    return <SsoSettingsResource>$resource(
        API_URL.SSO,
        { id: '@id' },
        {
            restApiSetEnabled: {
                method: 'POST',
                url: API_URL.SSOSETTINGS + '/:id/rest-api/enabled',
                params: {
                    id: '@id'
                }
            },
            restApiIsEnabled: {
                method: 'GET',
                url: API_URL.SSOSETTINGS + '/:id/rest-api/enabled',
                params: {
                    id: '@id'
                },
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            restApiToken: {
                method: 'GET',
                url: API_URL.SSOSETTINGS + '/:id/rest-api/token',
                params: {
                    id: '@id'
                }
            },
            restApiSupported: {
                method: 'GET',
                url: API_URL.SSOSETTINGS + '/:id/rest-api/support-started',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            saveAllocationServiceSubscription: {
                method: 'POST',
                url:
                    API_URL.SSOSETTINGS +
                    '/:id/storage-settings/allocation-service-subscription',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            queryAllocationServiceSubscription: {
                method: 'GET',
                url:
                    API_URL.SSOSETTINGS +
                    '/:id/storage-settings/allocation-service-subscription',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            queryFcfsService: {
                method: 'GET',
                url: API_URL.SSOSETTINGS + '/:id/storage-settings/fcfs-service',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            saveFcfsServiceEnabled: {
                method: 'POST',
                url:
                    API_URL.SSOSETTINGS +
                    '/:id/storage-settings/fcfs-service-enabled',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            },
            saveFcfsServiceUrls: {
                method: 'POST',
                url:
                    API_URL.SSOSETTINGS +
                    '/:id/storage-settings/fcfs-service-urls'
            },
            creditLimitEnabled: {
                method: 'GET',
                url:
                    API_URL.SSOSETTINGS +
                    '/storage-settings/credit-limit-enabled',
                interceptor: {
                    response: (response: ng.resource.IResourceResponse) =>
                        response.data
                }
            }
        }
    );
}
